import { elk } from './libs/elk';

var localStorage = window.localStorage;

function processKey(key) {
  return '$_' + key;
}

/**
 * 写入缓存
 * @param {[type]} key    [description]
 * @param {[type]} value  [description]
 * @param {[int]} expire [过期时间，单位是ms]
 */
function setItem(key, value, expire) {
  key = processKey(key);
  var data = {
    value: value,
    expire: new Date().getTime() + (expire || 1000)
  }
  try {
    var str = JSON.stringify(data);
    localStorage.setItem(key, str);
    return Promise.resolve(true);
  } catch (er) {
    return Promise.reject(er);
  }
}

function setItemSync(key, value, expire) {
  key = processKey(key);
  var data = {
    value: value,
    expire: new Date().getTime() + (expire || 1000)
  }
  var str = JSON.stringify(data);
  try{
    localStorage.setItem(key, str);
  } catch(err){
    //监控先加一段时间，后续会干掉
    elk({
        key: 'localstorage.setItem_error',
        str1: 'setItemSync',
        str2: 'first_time'
    });
    
    try{
      //setItem在android下，如果满了，就会抛异常，这里的解决办法是，先清空，再存一次
      localStorage.clear();
      localStorage.setItem(key, str);
    }catch(err){
      elk({
          key: 'localstorage.setItem_error',
          str1: 'setItemSync',
          str2: 'twice_time'
      });
    }
  }
  return true;
}

/**
 * 读出缓存，如果缓存不存在或者过期，则返回 null
 * @param  {[type]} key [description]
 * @return {[Promise]}     []
 */
function getItem(key) {
  key = processKey(key);
  var data = localStorage.getItem(key);
  if (!data) return Promise.resolve(null);
  try {
    var json = JSON.parse(data);
    if (json.expire < new Date().getTime()) {
      return Promise.resolve(null);
    } else {
      return Promise.resolve(json.value);
    }
  } catch (er) {
    return Promise.resolve(data);
  }
}

function getItemSync(key) {
  key = processKey(key);
  var data = localStorage.getItem(key);
  if (!data) return null;
  try {
    var json = JSON.parse(data);
    if (json.expire < new Date().getTime()) {
      return null;
    } else {
      return json.value;
    }
  } catch (er) {
    return data;
  }
}

/**
 * 移除缓存
 * @param  {[type]} key [description]
 * @return {[type]}     [description]
 */
function removeItem(key) {
  key = processKey(key);
  localStorage.removeItem(key);
  return Promise.resolve();
}

/**
 * 清空缓存
 * @return {[type]} [description]
 */
function clear() {
  localStorage.clear();
  return Promise.resolve();
}

function getAllKeys() {
  var ar = [];
  for (var i = 0, len = localStorage.length; i < len; i++) {
    ar.push(localStorage.key(i))
  }
  return Promise.resolve(ar);
}

function length() {
  return Promise.resolve(localStorage.length);
}

export {
    getItem,
    setItem,
    getItemSync,
    setItemSync,
    removeItem,
    clear,
    getAllKeys,
    length,
}

export default {
  getItem,
  setItem,
  getItemSync,
  setItemSync,
  removeItem,
  clear,
  getAllKeys,
  length,
}
